import Closed from "./Closed";
import Opened from "./Opened";
import Home from "./Home";
import ChildFree from "./ChildFree";
import Add from "./Add";
import Delete from "./Delete";
import Edit from "./Edit";

export default { Closed, Opened, Home, ChildFree, Add, Delete, Edit };
